export default {
  placeholder: 'Rechercher une entreprise...',
};
